<div>
  <div *ngIf="listData?.advanceNotPending?.length > 0">
    <span class="heading-class sp-font-size-32">Fulfilling {{listData?.advanceNotPending?.length}} Order(s)</span>
  </div>
  <div *ngIf="listData?.advanceNotPending?.length == 0">
    <span class="heading-class sp-font-size-32">Accepting {{listData?.advancePending?.length}} Order(s)</span>
  </div>
  <div class="sp-top-padding-20 sp-bottom-padding-20">
    <span class="body-text Inter-Regular sp-font-size-14">
      Certain order(s) where an advance payment is applicable do not qualify for invoice generation, please generate
      invoice individually.
    </span>
  </div>
  <hr />
  <div class="sp-top-padding-20 sp-bottom-padding-55">
    <span class="Inter-Medium">
      {{listData?.advancePending?.length}} of {{listData?.selectedOrder?.length}} Selected Open Order(s) do not qualify
      for invoice generation.
    </span>
  </div>
  <hr />
  <div class="sp-top-padding-12 app-space-between ">
    <div class="cancel-btn pointer-class" (click)="onCancel()">Cancel</div>
    <div *ngIf="listData?.advanceNotPending?.length > 0">
      <button class="fulfill-button Inter-Regular pointer-class" mat-raised-button (click)="fullfillOrder()">
        Generate Invoice
      </button>
    </div>
    <div *ngIf="listData?.advanceNotPending?.length == 0">
      <button class="fulfill-button Inter-Regular pointer-class" mat-raised-button (click)="fullfillOrder()">
        Accept Order
      </button>
    </div>
  </div>
</div>
